<h4 mat-dialog-title>Ajouter un type d'aide</h4>
<mat-dialog-content style="min-height: 80px;">
  <fieldset>
    <label for="labelItem">Label : </label>
    <input class="form-control" id="labelItem" style="min-width: 300px" type="text" [(ngModel)]="item.label" required>
  </fieldset>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn " [mat-dialog-close]="false" style="margin-right: 15px;">Annuler</button>
  <button class="btn  btn-primary" color="primary" [mat-dialog-close]="item">Ajouter</button>
</mat-dialog-actions>
